import { useAuthModal } from "../contexts/AuthModalContext";
import { useHeaderContext } from "../contexts/HeaderContext";

export const Header = () => {
  const { actions } = useHeaderContext();
  const { showAuthModal } = useAuthModal();

  const handleSignIn = (event: MouseEvent) => {
    event.preventDefault();
    showAuthModal();
  };

  return (
    <header class="fixed top-0 w-full z-1000 lg:hidden">
      <div class="flex justify-between items-center max-w-lg h-14 px-4 backdrop-blur bg-gradient-to-b from-white/95 via-white/80 to-white/60 dark:from-neutral-900/95 dark:via-neutral-900/80 dark:to-neutral-900/60 shadow-lg dark:shadow-[0_5px_10px_rgba(128,128,128,0.1)]">
        <h1 class="text-3xl font-bold text-neutral-700 dark:text-neutral-50 flex items-center gap-2">
          <a href="/">!tldr</a>
          <a
            href="/auth"
            onClick={handleSignIn}
            class="hidden-signedin px-3 py-1.5 text-sm bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold rounded-lg hover:from-blue-700 hover:to-purple-700 transition-all shadow-lg text-center"
            data-test-click="sign-in-header"
          >
            Sign in
          </a>
        </h1>
        <div class="flex h-full">{actions}</div>
      </div>
    </header>
  );
};
